import type { ComponentProps } from 'react';

const SearchHospitalIcon = (props: ComponentProps<'svg'>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="56"
    height="56"
    viewBox="0 0 56 56"
    fill="none"
    {...props}
  >
    <path
      d="M29.8312 34.5413C29.8312 34.5413 31.2104 26.9636 35.0199 27.9617C38.8294 28.9598 47.9578 38.6632 47.9578 38.6632L36.3339 50.8266L31.6057 45.643L24.6426 38.4631L29.8312 34.5413Z"
      fill="#FFBF9F"
    />
    <path
      d="M36.334 50.8177L40.4063 55.6717L52.5558 42.708L47.9579 38.6543L36.334 50.8177Z"
      fill="#EA7A0A"
    />
    <path
      d="M40.3424 52.3167C40.9404 52.3167 41.4251 51.8261 41.4251 51.2208C41.4251 50.6156 40.9404 50.125 40.3424 50.125C39.7445 50.125 39.2598 50.6156 39.2598 51.2208C39.2598 51.8261 39.7445 52.3167 40.3424 52.3167Z"
      fill="#FBAE17"
    />
    <path
      d="M23.3848 31.0628C23.551 31.1742 31.4013 40.0319 35.0311 44.1334C35.2686 44.4009 35.556 44.6184 35.8767 44.7731C36.1975 44.9278 36.5453 45.0169 36.9002 45.035C37.2551 45.0532 37.61 45.0002 37.9446 44.879C38.2791 44.7578 38.5867 44.5709 38.8496 44.3289C39.3767 43.8404 39.6905 43.16 39.7221 42.4374C39.7537 41.7147 39.5005 41.009 39.0181 40.4753L27.037 27.3047L23.3848 31.0628Z"
      fill="#792D2C"
    />
    <path
      d="M34.9497 43.6126C34.5004 46.1476 30.5315 47.846 28.1438 47.3935C28.1438 47.3935 25.4102 47.0593 26.2076 44.3652C26.2076 44.3652 22.9461 43.4126 24.341 40.2728C24.341 40.2728 21.3873 39.1952 22.3487 36.8352C22.5205 36.4343 22.7774 36.0765 23.1011 35.7873C23.4249 35.4981 23.8076 35.2846 24.222 35.1619L28.1954 34.3525C29.5094 33.9388 30.1474 34.4526 30.5404 35.7871C30.7448 36.4692 30.6707 37.3195 29.9766 38.288C29.9766 38.288 33.5997 38.1311 32.5216 41.6983C32.5216 41.7165 35.3315 41.4482 34.9497 43.6126Z"
      fill="#FFBF9F"
    />
    <path
      d="M28.1065 44.8992C27.4041 44.9001 26.7088 44.757 26.0625 44.4786L26.6757 43.0122C29.4969 44.2217 32.4349 41.232 32.4641 41.1934L33.5872 42.3028C33.4681 42.4393 31.0647 44.8992 28.1065 44.8992Z"
      fill="#E27560"
    />
    <path
      d="M25.8655 40.6038C25.3353 40.6033 24.8071 40.5361 24.2932 40.4037L24.6796 38.8623C26.4001 39.317 28.6845 38.7168 29.529 36.9707L30.9419 37.6687C30.0636 39.4875 28.0331 40.6038 25.8655 40.6038Z"
      fill="#E27560"
    />
    <path
      d="M38.8105 39.5246C34.4102 38.1946 35.4614 33.6748 35.4614 33.6748C33.4264 37.9285 30.6007 37.1987 30.6007 37.1987C30.6007 37.1987 28.9588 36.6008 29.2216 34.4705C29.2216 34.4705 30.1807 31.9423 31.3667 30.2599C33.3388 27.468 35.6142 28.2137 36.9709 30.3054C38.3276 32.397 41.3509 35.7619 41.3509 35.7619L38.8105 39.5246Z"
      fill="#FFBF9F"
    />
    <path
      d="M38.7975 40.0199C36.5176 39.3378 35.3159 37.6213 34.6893 36.1754C34.1096 37.0383 33.2432 37.6619 32.2477 37.9328C31.1246 38.242 30.3676 37.9055 29.9207 37.5668C28.5438 36.5255 28.4629 34.211 28.4629 34.1883L30.0352 34.1587C30.0554 34.5543 30.2598 35.848 30.873 36.3004C31.028 36.4141 31.2953 36.5459 31.8321 36.3982C33.7391 35.8684 34.0379 33.6949 34.0401 33.6699L35.6012 33.6858C35.6192 33.8404 36.0774 37.5349 39.249 38.4944L38.7975 40.0199Z"
      fill="#E27560"
    />
    <path
      d="M33.3786 47.5099L32.2285 46.4255C33.547 44.9909 34.7487 43.87 34.8004 43.8223L35.8628 44.9954C35.8516 45.0068 34.6544 46.1231 33.3786 47.5099Z"
      fill="#E27560"
    />
    <path
      d="M21.2285 29.2136L23.2501 32.0055C23.2501 32.0055 27.118 30.1572 28.8812 26.8764L26.5924 24.1914C26.5924 24.1914 24.8201 28.0359 21.2285 29.2136Z"
      fill="#E16257"
    />
    <path
      d="M8.33234 27.5071L7.83594 0.488489L23.3008 0.00195312L23.795 26.7796L16.6364 29.7238L8.33234 27.5071Z"
      fill="#5BB0AA"
    />
    <path
      d="M9.95703 15.0152L10.0379 17.8367L12.4615 17.798L12.4368 14.9766L9.95703 15.0152Z"
      fill="#75CAC3"
    />
    <path
      d="M14.8086 14.9257L14.8872 17.7471L17.3108 17.7085L17.2884 14.8848L14.8086 14.9257Z"
      fill="#75CAC3"
    />
    <path
      d="M19.5723 14.8297L19.6531 17.6511L22.0767 17.6125L22.052 14.791L19.5723 14.8297Z"
      fill="#75CAC3"
    />
    <path
      d="M9.93164 20.4078L10.0125 23.2315L12.4361 23.1906L12.4114 20.3691L9.93164 20.4078Z"
      fill="#75CAC3"
    />
    <path
      d="M14.7773 20.316L14.8582 23.1374L17.2818 23.0988L17.2571 20.2773L14.7773 20.316Z"
      fill="#75CAC3"
    />
    <path
      d="M19.5469 20.2362L19.6255 23.0577L22.0514 23.019L22.0266 20.1953L19.5469 20.2362Z"
      fill="#75CAC3"
    />
    <path
      d="M16.4717 2.94614L14.5469 2.96484L14.628 11.5198L16.5529 11.501L16.4717 2.94614Z"
      fill="white"
    />
    <path
      d="M19.7712 6.09415L11.1663 6.13672L11.1757 8.08511L19.7806 8.04255L19.7712 6.09415Z"
      fill="white"
    />
    <path
      d="M15.4388 31.3389C12.5497 31.3401 9.73434 30.4155 7.39627 28.6976C5.0582 26.9797 3.31743 24.5568 2.42343 21.7759C1.52943 18.9951 1.5281 15.9992 2.41962 13.2176C3.31115 10.436 5.04977 8.01145 7.3863 6.29144L7.91416 5.90039L7.99502 9.42891L7.88945 9.53349C6.83843 10.5693 6.00116 11.8061 5.42624 13.1721C4.85133 14.5381 4.55023 16.0061 4.54042 17.4909C4.49857 18.9655 4.7494 20.4337 5.27804 21.8086C5.80669 23.1834 6.60242 24.4369 7.61815 25.495C8.63388 26.553 9.84897 27.3941 11.1915 27.9685C12.5341 28.5428 13.9768 28.8387 15.4343 28.8387C16.8919 28.8387 18.3346 28.5428 19.6771 27.9685C21.0197 27.3941 22.2348 26.553 23.2505 25.495C24.2662 24.4369 25.062 23.1834 25.5906 21.8086C26.1192 20.4337 26.3701 18.9655 26.3282 17.4909C26.3524 14.7624 25.3659 12.1238 23.5632 10.0951L23.4778 9.99957L23.3992 6.1914L23.9675 6.64611C26.1879 8.43578 27.8032 10.8802 28.5897 13.6407C29.3762 16.4011 29.2948 19.3408 28.3569 22.0524C27.419 24.7639 25.6711 27.113 23.3552 28.7741C21.0394 30.4352 18.2704 31.326 15.4321 31.323L15.4388 31.3389Z"
      fill="#F68E7A"
    />
  </svg>
);

export default SearchHospitalIcon;
